import { splashScreenOpenRequested } from 'features/breakout-rooms/actions';
import { roomMovementRequested } from 'features/breakout-rooms/breakoutRoomsSlice';
import { call, put } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { cleanupBreakoutRoomsNotificationsSaga } from 'features/breakout-rooms/sagas/cleanupBreakoutRoomsNotificationsSaga';

export function* onBreakoutRoomsStoppedSaga() {
  // reset only if in a BR. If in a main room, do nothing;
  if (RTCClient.roomId === RTCClient.breakoutRoomId) {
    yield put(splashScreenOpenRequested('ended'));

    yield put(roomMovementRequested());
  } else {
    yield call(cleanupBreakoutRoomsNotificationsSaga);
  }
}
